export class Status {
  public id: number;
  public userId: number;
  public value: string;
  public isArchived: boolean = false;
  public createdAt: Date;
  public updatedAt: Date;
}
